<template>
    <section>
        <div class="container-fluid imagescontainer shadow"  :class="{picimagesection: picimagetheme==='picimagesection'}">
          <div class="row  ">
            <div class="colcol-sm-12 col-md-4 col-lg-4 col-xxl-4 rounded">
              <img :src="`${cmimage1}`" class="imageswidth shadow">
            </div>
            <div class="col col-sm-12 col-md-4 col-lg-4 col-xxl-4 rounded">
              <img :src="`${cmimage2}`" class="imageswidth shadow">
            </div>
            <div class="col col-sm-12 col-md-4 col-lg-4 col-xxl-4 rounded">
              <img :src="`${cmimage3}`" class="imageswidth rounded shadow">
            </div>
          </div>
        </div>
    </section>
</template>

<script>

export default {
    props: ['picimagesection', 'cmimage1', 'cmimage2', 'cmimage3']
}
</script>

<style scoped>
/*===================MEDIA SCREENS TAMPLATES===============*/
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
    .iconsize {
      width: 60%;
      padding: 20px;
     }
     .col {
        min-width: 100%;
     }

     .imageswidth {
        width: 100%;
        margin-top: 40px;
        padding: 20px;
     }
    }
    
    /* Small devices (portrait tablets and large phones, 600px and up) */
    @media only screen and (min-width: 600px) {
    .iconsize {
        width: 60%;
        padding: 20px;
        }
    .col {
        min-width: 100%;
    }

    .imageswidth {
        width: 100%;
        margin-top: 40px;
        padding: 40px;
    }
    }
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        background-color: #003;
      }
    /* Medium devices (landscape tablets, 768px and up) */
    @media only screen and (min-width: 768px) {
        .iconsize {
            width: 60%;
            padding: 20px;
            }
        .col {
            min-width: 33%;
        }
    
        .imageswidth {
            width: 100%;
            margin-top: 40px;
            padding: 0;
        }
    }
    /* Large devices (laptops/desktops, 992px and up) */
    @media only screen and (min-width: 992px) {
        .iconsize {
            width: 60%;
            padding: 20px;
            }
        .col {
            min-width: 25%;
        }
    
        .imageswidth {
            width: 100%;
            margin-top: 40px;
            padding: 0;

        }
    }
    
    /* Extra large devices (large laptops and desktops, 1200px and up) */
    @media only screen and (min-width: 1200px) {
    
    } 
</style>